import PageMaxLayout from './PageMaxLayout';

export default PageMaxLayout;
